import VoucherLikePromo from './VoucherLikePromo';

import RedeemOfferWithCode from './RedeemOfferWithCode';
import CaptureTheMoments from './CaptureTheMoments';
import StampCardModal from './StampCard';
import { showPromo } from './utils';

import './promotions.css';

const PROMOTIONS = [
    { name: 'SSW', component: RedeemOfferWithCode },
    { name: 'CaptureTheMoments', component: CaptureTheMoments },
    { name: 'StampCard', component: StampCardModal },
]

export { VoucherLikePromo, showPromo, PROMOTIONS }